export const PHARMACY_STATE_CODES = ['QLD', 'NSW', 'VIC', 'ACT', 'SA', 'TAS', 'WA', 'NT'];

export const STATE_TIMEZONE_MAP = {
  QLD: ['E. Australia Standard Time'],
  NSW: ['AUS Eastern Standard Time'],
  VIC: ['AUS Eastern Standard Time'],
  ACT: ['AUS Eastern Standard Time'],
  SA: ['AUS Central Standard Time'],
  TAS: ['Tasmania Standard Time', 'AUS Eastern Standard Time'],
  WA: ['W. Australia Standard Time'],
  NT: ['AUS Central Standard Time'],
};

export function getDefaultTimezoneForState(state) {
  const allowed = STATE_TIMEZONE_MAP[state];
  return allowed ? allowed[0] : null;
}

export function isTimezoneValidForState(state, timezone) {
  if (!state || !timezone) return true;
  const allowed = STATE_TIMEZONE_MAP[state];
  if (!allowed) return true;
  return allowed.includes(timezone);
}

export function getPharmacyStateOptions(statesSource, currentState) {
  if (!currentState || statesSource.some((option) => option.value === currentState)) {
    return statesSource;
  }

  return [...statesSource, { label: currentState, value: currentState }];
}
